import React from "react";
import { FiHome } from "react-icons/fi";
import AccordionSection from "./AccordionSection";
import DropdownField from "./DropdownField";
import InputField from "./InputField";

const PropertyDetailsForm = ({
  formData,
  currentConfig,
  isExpanded,
  onToggleSection,
  transitionStyle,
  activeDropdown,
  onDropdownToggle,
  onFormDataChange,
  createRefCallback,
  onCloseDropdown,
}) => {
  if (!formData.propertyType || !currentConfig) {
    return null;
  }

  const renderDropdownField = (field) => (
    <DropdownField
      key={field.key}
      field={field}
      value={formData[field.key]}
      isOpen={activeDropdown === field.key}
      onToggle={onDropdownToggle}
      onChange={(key, value) => {
        onFormDataChange(key, value);
        onCloseDropdown();
      }}
      createRefCallback={createRefCallback}
      formData={formData}
    />
  );

  const renderInputField = (field) => (
    <InputField
      key={field.key}
      field={field}
      value={formData[field.key]}
      onChange={onFormDataChange}
    />
  );

  return (
    <AccordionSection
      title="Thông tin chi tiết bất động sản"
      isExpanded={isExpanded}
      toggleExpand={onToggleSection}
      icon={<FiHome className="text-green-600" />}
      transitionStyle={transitionStyle}
    >
      {/* Render dropdown fields */}
      {currentConfig.dropdownFields.map(renderDropdownField)}

      {/* Render input fields */}
      {currentConfig.inputFields.map(renderInputField)}
    </AccordionSection>
  );
};

export default PropertyDetailsForm;
